import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar.js";
import AdminFooter from "./AdminFooter.js";
import AdminHeader from "./AdminHeader.js";
import {
  server_post_data,
  save_amount_pay_remaing,
  get_all_customer_booking,
} from "../../ServiceConnection/serviceconnection.js";
import {
  check_vaild_save,
  combiled_form_data,
  handleIaphabetnumberChange,
  handleNumbersDecimalChange,
  handleSuccessSession,
  handleError,
  inputdateformateChange,
  handleLinkClick,
} from "../../CommonJquery/CommonJquery.js";
import { useLocation, Link } from "react-router-dom";
import { retrieveData } from "../../LocalConnection/LocalConnection.js";
function CustomerBookingDashboardDetails() {
  const location = useLocation();
  const currentUrl = location.pathname.substring(1);
  const [editorDataMainID, setEditorDatMainID] = useState("0");
  const [editBlogData, seteditBlogData] = useState([]);
  const [MenulistSelectedData, setMenulistSelectedData] = useState([]);
  const [ProcesslistData, setProcesslistData] = useState([]);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [RUPESSICON, setRUPESSICON] = useState("₹");
  const retrievedAdminId = retrieveData("staff_id");
  const retrievedAdminName = retrieveData("admin_name");
  const [data_eventtiming, setdata_eventtiming] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [catagorydata, setcatagorydata] = useState([]);
  const handlePaymentMethodChange = (e) => {
    const selectedMethod = e.target.value;
    setSelectedPaymentMethod(selectedMethod);
  };
  useEffect(() => {
    const url = currentUrl;
    const parts = url.split("/");
    const start_date = "";
    const end_date = "";
    const flag = "3";
    let call_id = "0";
    if (parts.length !== 1) {
      call_id = parts[1];
    }
    master_data_get(start_date, end_date, flag, call_id);
  }, []);

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("admin_id", retrievedAdminId);
    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    await server_post_data(get_all_customer_booking, fd)
      .then((Response) => {
        console.log(Response.data.message);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          if (Response.data.message.data_main_lead.length > 0) {
            seteditBlogData(Response.data.message.data_main_lead[0]);
            setEditorDatMainID(
              Response.data.message.data_main_lead[0].primary_id
            );
          }
          setMenulistSelectedData(Response.data.message.data_menuselectlist);
          setcatagorydata(Response.data.message.data_menuselectlist1);
          setProcesslistData(Response.data.message.data_legerAmount);
          setRUPESSICON(Response.data.message.rupess_icon);
          setdata_eventtiming(Response.data.message.data_eventtiming);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
      });
  };

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);
    if (vaild_data) {
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, null);
      fd_from.append("staff_id", retrievedAdminId);
      fd_from.append("staff_name", retrievedAdminName);
      fd_from.append("amount_discount_percentage", "0");
      fd_from.append("taken_bank_name", "");
      fd_from.append("main_id", editorDataMainID);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            handleSuccessSession(
              Response.data.message,
              "/CustomerBookingDashboardView"
            );
          }
        })
        .catch((error) => {
          setshowLoaderAdmin(false);
        });
    }
  };
  // console.log(MenulistSelectedData);
  return (
    <div className="app-container app-theme-white body-tabs-shadow fixed-header">
      <div className={showLoaderAdmin ? "loading_website" : ""}></div>
      <AdminHeader />

      <div className="app-main">
        <AdminSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner">
            <div className="app-page-title">
              <div className="page-title-wrapper">
                <div className="page-title-heading">
                  <Link to="/admindashboard">
                    <div className="page-title-icon">
                      <i className="fa fa-home icon-gradient bg-mean-fruit"></i>
                    </div>
                  </Link>
                  <div>
                    Confirm Booking Dashboard
                    <div className="page-title-subheading">
                      Confirm Booking Enquiry
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="main-card mb-3 card">
              <div className="card-body">
                <h5 className="card-title">Customer Booking Process</h5>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <ul className="list-group">
                      <button className=" list-group-item-action list-group-item">
                        Person Name :-
                        <span className="float_right_show">
                          {editBlogData.customer_person_name || ""}
                        </span>
                      </button>
                      <button className=" list-group-item-action list-group-item">
                        Company Name :-
                        <span className="float_right_show">
                          {editBlogData.person_company_name || ""}
                        </span>
                      </button>
                      <button className=" list-group-item-action list-group-item">
                        Mobile No :-
                        <span className="float_right_show">
                          {editBlogData.person_mobile_no || ""}
                        </span>
                      </button>
                    </ul>
                  </div>
                  <div className="col-md-6 mb-3">
                    <ul className="list-group">
                      <button className=" list-group-item-action list-group-item">
                        Event Date :-
                        <span className="float_right_show">
                          {editBlogData.event_date || ""}
                        </span>
                      </button>
                      <button className=" list-group-item-action list-group-item">
                        No of Guest :-
                        <span className="float_right_show">
                          {editBlogData.event_no_of_person_come || ""}
                        </span>
                      </button>
                      {editBlogData.special_requirement &&
                        editBlogData.special_requirement.length > 2 && (
                          <button className=" list-group-item-action list-group-item">
                            Special Requirement :-
                            <span className="float_right_show">
                              {editBlogData.special_requirement || ""}
                            </span>
                          </button>
                        )}
                    </ul>
                  </div>
                  <div className="col-md-6 mb-3">
                    <ul className="list-group">
                      <button className=" list-group-item-action list-group-item">
                        Total Amount :-
                        <span className="float_right_show">
                          {RUPESSICON} {editBlogData.final_amount || ""}
                        </span>
                      </button>
                      <button className=" list-group-item-action list-group-item">
                        Advance Amount :-
                        <span className="float_right_show">
                          {RUPESSICON} {editBlogData.advance_amount || ""}
                        </span>
                      </button>
                    </ul>
                  </div>
                  <div className="col-md-6 mb-3">
                    <ul className="list-group">
                      <button className=" list-group-item-action list-group-item">
                        Event Timing :-
                        <span className="float_right_show">
                          {/* {data_eventtiming.map((data_get) => {
                            if (
                              Number(data_get.primary_id) ===
                              Number(editBlogData.customer_for_eventtiming_id)
                            ) {
                              return (
                                <span
                                  className="float_right_show"
                                  key={data_get.primary_id}
                                >
                                  {editBlogData.customer_event_list_name}{" "}
                                  {data_get.timing_name} ({data_get.timing_from}{" "}
                                  - {data_get.timing_to})
                                </span>
                              );
                            }
                            return null; // You may want to handle the case when there is no match
                          })} */}
                          {editBlogData.event_timing_from}-
                          {editBlogData.event_timing_to}
                        </span>
                      </button>
                      <button className=" list-group-item-action list-group-item">
                        Balance Amount :-
                        <span className="float_right_show">
                          {RUPESSICON}{" "}
                          {(
                            Number(editBlogData.final_amount) -
                            Number(editBlogData.advance_amount)
                          ).toFixed(2)}
                        </span>
                      </button>
                    </ul>
                  </div>
                  {MenulistSelectedData.length > 0 && (
                    <div className="col-md-12 mb-3">
                      <h5 className="card-title">Menu Name</h5>
                      <ul className="list-group">
                        {MenulistSelectedData.map((blogdddddd, index) => (
                          <button
                            className=" list-group-item-action list-group-item"
                            key={index}
                          >
                            {blogdddddd.venue_name}
                            <span className="float_right_show">
                              <p>
                                Category :-
                                {catagorydata[0].category_master_name}
                              </p>
                            </span>
                          </button>
                        ))}
                      </ul>
                    </div>
                  )}
                  {ProcesslistData.length > 0 && (
                    <div className="col-md-12 mb-3">
                      <h5 className="card-title">Payment Progress</h5>
                      <ul className="list-group">
                        {ProcesslistData.map((blogdddddd, index) => (
                          <button
                            className=" list-group-item-action list-group-item"
                            key={index}
                          >
                            <div className="row">
                              <div className="col-md-4 ">
                                {inputdateformateChange(blogdddddd.entry_date)}
                              </div>
                              <div className="col-md-2 ">
                                <span className="min_center">
                                  {blogdddddd.taken_from}
                                </span>
                              </div>
                              <div className="col-md-6 ">
                                <span className="float_right_show">
                                  {RUPESSICON} {blogdddddd.amount_taken}
                                </span>
                              </div>
                            </div>
                          </button>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                {editBlogData.final_amount !== editBlogData.advance_amount && (
                  <form className="needs-validation" id="CarrerformData">
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <label htmlFor="validationCustom01">
                          Received Amount
                        </label>
                        <input
                          type="text"
                          className="form-control trio_mandatory length_min"
                          name="amount_taken"
                          id="amount_taken"
                          maxLength={10}
                          onInput={handleNumbersDecimalChange}
                          placeholder="Enter Received Amount"
                        />
                        <span className="condition_error"></span>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label htmlFor="validationCustom01">
                          Payment Method<span className="red_show">*</span>
                        </label>
                        <select
                          className="form-control trio_mandatory"
                          name="taken_from"
                          id="taken_from"
                          onChange={handlePaymentMethodChange}
                        >
                          <option value="" disabled selected hidden>
                            Select Payment Method
                          </option>
                          <option value="UPI">UPI</option>
                          <option value="Bank Transfer">Bank Transfer</option>
                          <option value="Cash">Cash</option>
                        </select>
                      </div>
                      {selectedPaymentMethod !== "Cash" && (
                        <div className="col-md-4 mb-3">
                          <label htmlFor="validationCustom01">
                            Transfer Id (Optional)
                          </label>
                          <input
                            type="text"
                            className="form-control  "
                            name="taken_transaction_id"
                            id="taken_transaction_id"
                            maxLength={150}
                            onInput={handleIaphabetnumberChange}
                            placeholder="Enter Transfer Id (Optional)"
                          />
                          <span className="condition_error"></span>
                        </div>
                      )}
                    </div>
                    <div className="row">
                      <div className="col-md-12 mb-3">
                        <label htmlFor="validationCustom01">Remark</label>
                        <textarea
                          type="text"
                          className="form-control  "
                          name="remark"
                          id="remark"
                          maxLength={400}
                          onInput={handleIaphabetnumberChange}
                          placeholder="Enter Remark"
                        ></textarea>
                        <span className="condition_error"></span>
                      </div>
                    </div>
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={() =>
                        handleSaveChangesdynamic(
                          "CarrerformData",
                          save_amount_pay_remaing
                        )
                      }
                    >
                      Submit
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
          <AdminFooter />
        </div>
      </div>
    </div>
  );
}
export default CustomerBookingDashboardDetails;
